/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerificationRequest
 */
export interface VerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof VerificationRequest
     */
    readonly id: string;
}

/**
 * Check if a given object implements the VerificationRequest interface.
 */
export function instanceOfVerificationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function VerificationRequestFromJSON(json: any): VerificationRequest {
    return VerificationRequestFromJSONTyped(json, false);
}

export function VerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerificationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function VerificationRequestToJSON(value?: VerificationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

